import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { CollectionsService } from 'src/app/services/common/collections.service';

@Component({
  selector: 'app-reg-person-payment-form',
  templateUrl: './reg-person-payment-form.component.html',
  styleUrls: ['./reg-person-payment-form.component.css']
})
export class RegPersonPaymentFormComponent implements OnInit {
  @Input() money: UntypedFormGroup;

  lstPaymentTypes = this.coll.PAYMENT_TYPES.slice();
  lstCompanies = this.coll.COMPANIES.slice();

  lstLogic: SelectItem[] = [
    { label: "Да", value: true},
    { label: "Нет", value: false},
  ];


  constructor(
    private coll: CollectionsService
  ) { }

  ngOnInit(): void {
  }

  onSetMoney(money: number) {
    this.money.controls['paymentAmount'].patchValue(money);
  }

}
